//
export default [
    // {
    //     field: 'g_branch_office_id',
    //     type: 'autocompleteObject',
    //     vuetifyProps: {
    //         label: 'Sucursal',
    //     },
    //     options: {
    //         data: [],
    //         text: 'address',
    //         value: 'id',
    //     },
    //     rules: [ 'required' ],
    // },
    {
        field: 'upc_code',
        type: 'text',
        vuetifyProps: {
            label: 'UPC',
        },
        rules: ['required'],
    },
    {
        field: 'minimum_stock',
        type: 'text',
        vuetifyProps: {
            label: 'Mínimo stock',
            mask: '########',
        },
        rules: ['required'],
    },
    {
        field: 'maximum_stock',
        type: 'text',
        vuetifyProps: {
            label: 'Máximo stock',
            mask: '########'
        },
        rules: ['required'],
    },
    {
        field: 'critical_stock',
        type: 'text',
        vuetifyProps: {
            label: 'Stock crítico',
            mask: '########'
        },
        rules: ['required'],
    },
    {
        field: 'cost_price',
        //format: 'currency',
        type: 'text',
        vuetifyProps: {
            label: 'Precio costo',
            mask: '#########'
        },
        rules: ['required'],
    },
    {
        field: 'sale_price',
        //format: 'currency',
        type: 'text',
        vuetifyProps: {
            label: 'Precio venta',
            mask: '########'
        },
        rules: ['required'],
    },
    {
        field: 'gains_margin',
        type: 'text',
        vuetifyProps: {
            label: 'Margen',
            suffix: '%',
        },
        readonly: true,
        rules: ['required'],
        value: 0,
    },
]
